<template>
  <div>
    <v-combobox
      v-if="autocomplete"
      ref="autocompleteServiceComponent"
      v-model.trim="modelStr"
      :autofocus="autofocus"
      :color="color"
      :dark="dark"
      :disabled="disabled"
      :error-messages="errorMessages"
      :hint="hint"
      :items="locationFoundItems"
      :loading="loading"
      :placeholder="placeholder"
      :prepend-inner-icon="geolocate ? 'mdi-crosshairs-gps' : 'mdi-map-marker'"
      :readonly="readonly"
      :rules="rules"
      :search-input.sync="locationSearchText"
      class="pt-0 mt-0"
      clearable
      filled
      hide-details="auto"
      hide-no-data
      item-text="Name"
      no-filter
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      @click:clear="clearIconCb"
      @click:prepend-inner="geolocateUser"
    />

    <v-text-field
      v-else
      ref="autocompleteServiceComponent"
      v-model.trim="locationSearchText"
      :autofocus="autofocus"
      :color="color"
      :dark="dark"
      :disabled="disabled"
      :error-messages="errorMessages"
      :hint="hint"
      :loading="loading"
      :placeholder="placeholder"
      :readonly="readonly"
      :rules="rules"
      clearable
      filled
      hide-details="auto"
      prepend-inner-icon="mdi-map-marker"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      @click:clear="clearIconCb"
    />

    <v-map
      v-if="map && !mapRef"
      :address-marker="markerLatLng"
      :height="mapHeight"
      :map-center="markerLatLng"
      :map-styles="mapStyles"
      :map.sync="mapObj"
      :store-marker="storeMarker"
      :width="mapWidth"
      class="mt-3"
      draggable
      show-address-marker
      @dragend="onMarkerDragEnd"
    />
  </div>
</template>

<script>

import VMapAutocompleteServiceMixin from '@/theme/default/components/map/VMapAutocompleteService.js'

export default {
  name  : 'VMapAutocompleteService',
  mixins: [VMapAutocompleteServiceMixin]
}
</script>

<style scoped src="@/theme/default/components/map/VMapAutocompleteService.css"></style>

<style scoped>
</style>
